<template>
  <div>
  <v-list flat>
    <v-list-item-group>
      <v-list-item
        v-bind:key="option.key"
        v-for="option in options"
        @click="$emit('add-option', option)"
      >
        <v-list-item-title>{{ option.name }}</v-list-item-title>
      </v-list-item>
    </v-list-item-group>
  </v-list>
  </div>
</template>

<script>
export default {
  name: "AddCustomizationModal",
  props: {
    settings: Array,
  },
  computed: {
    options() {
      return this.$store.getters.getScreenOptions;
    },
  },
};
</script>